
import { LazyLoadImage } from "react-lazy-load-image-component";
import { MESSAGE_TYPE, s3Link } from "../../utils/constants";
import React, { useEffect, useState } from "react";
import moment from 'moment';
import PriceText from '../PriceText';
import CountDownTimer from "../CountDownTimer";

const BundleMedia = ({ message }) => {
    const [isDiscounted, setIsDiscounted] = useState(false);

    const purchased = () => {
        return (message.msg_type === MESSAGE_TYPE.PURCHASED);
    };

    const free = () => {
        return (message.msg_type === MESSAGE_TYPE.NO_PRICE) || ((message.paid === 0) && (message.price < 1));
    };

    const hasFreePreview = () => {
        return message.medias && message.medias.length > 0 && message.medias[0].free_preview;
    };

    const handleEndTime = () => {
        setIsDiscounted(false);
    };

    useEffect(() => {
        const validDate = moment(message.expire_at).isValid();

        if (parseFloat(message.promo_price) > 0 && message.expire_at && !!validDate) {
            const expiry = moment.utc(message.expire_at).local();
            if (moment().isSameOrAfter(expiry, 'seconds')) {
                setIsDiscounted(false);
            } else {
                setIsDiscounted(true);
            }
        }
    }, [message]);

    return <>
        <div className="media-container bundle-media"
            key={`${message.id}`}
        >
            {
                purchased() || free()
                    ? <div className="media-item-unlocked" style={{ backgroundImage: `url('${s3Link}/${message.medias[0].thumb_path}')` }}>
                        {(!purchased() && !free()) && <LazyLoadImage className="lock-icon" src="./../../images/silver-app.png" />}
                        {
                            message.price > 0 && <div className="media-price">
                                <PriceText
                                    price={message.price}
                                    discountedPrice={message.promo_price}
                                    isDiscounted={!!message.expire_at}
                                />
                            </div>
                        }
                    </div>
                    : <>
                        {
                            hasFreePreview()
                                ? <div className="media-item-unlocked" style={{ backgroundImage: `url('${s3Link}/${message.medias[0].thumb_path}')` }}>
                                    {(!purchased() && !free()) && <LazyLoadImage className="lock-icon" src="./../../images/silver-app.png" />}
                                    {
                                        message.price > 0 && <div className="media-price">
                                            <PriceText
                                                price={message.price}
                                                discountedPrice={message.promo_price}
                                                isDiscounted={isDiscounted}
                                            />
                                        </div>
                                    }
                                </div>
                                : <div className="media-item-locked">
                                    {(!purchased() && !free()) && <LazyLoadImage className="lock-icon" src="./../../images/silver-app.png" />}
                                    {
                                        message.price > 0 && <div className="media-price">
                                            <PriceText
                                                price={message.price}
                                                discountedPrice={message.promo_price}
                                                isDiscounted={isDiscounted}
                                            />
                                        </div>
                                    }
                                </div>
                        }

                        {
                            isDiscounted
                                ? <div className='promo_counter display-none'>
                                    <span className="promo_counter_span">Limited offer expires in:</span>
                                    <CountDownTimer
                                        dateTime={message.expire_at}
                                        id={message.id}
                                        onEndTime={handleEndTime}
                                        isUTC
                                    />
                                </div>
                                : ''
                        }
                    </>
            }
        </div>
    </>;
};

export default BundleMedia;
